import SearchSearch from './SearchSearch';

export { type SearchSearchProps } from './SearchSearch';
export default SearchSearch;
